;(function () {
  'use strict'

  angular
    .module('contrast.date')
    .controller('csDateRangePickerPrimaryCtrl', csDateRangePickerPrimaryCtrl)

  function csDateRangePickerPrimaryCtrl(
    $translate,
    TimeService,
    ProfileService,
    UserService,
    csDateRangePickerPrimaryStates,
    DATE_OPTIONS
  ) {
    'ngInject'

    var vm = this

    var translGlobal = {}

    var defaultState
    var state
    var placeholder

    var options
    var invalidFreemiumOptions

    var previousStateNonCustom

    this.$onInit = function () {
      vm = this

      translGlobal = {
        placeholder_dateRangePicker_setDateRange: $translate.instant(
          'placeholder_dateRangePicker_setDateRange'
        )
      }

      defaultState = csDateRangePickerPrimaryStates.SELECT
      placeholder = translGlobal.placeholder_dateRangePicker_setDateRange

      options = []
      invalidFreemiumOptions = ['custom', 'lastMonth']

      previousStateNonCustom = null

      vm.isDropdownOpen = false
      vm.rangeInputValue = undefined
      vm.dateTimeFormat = ProfileService.getDateTimeFormat()

      vm.getPlaceholder = getPlaceholder
      vm.deleteDate = deleteDate
      vm.onHide = onHide
      vm.onSelect = onSelect
      vm.onItemSelect = onItemSelect
      vm.isState = isState
      vm.rangePickerOnChange = rangePickerOnChange
      vm.getPickerInputVal = getPickerInputVal
      vm.openDropdown = openDropdown
      vm.onChange = onChange
      vm.updateModel = updateModel

      activate()
    }

    function activate() {
      _determineSelectOptions()
      vm.model = {
        startDate: null,
        endDate: null
      }
      state = defaultState
    }

    function _determineSelectOptions() {
      var defaultKey = 'default'
      var key = angular.isString(vm.csDateRangeOptionsKey)
        ? vm.csDateRangeOptionsKey.toLowerCase()
        : defaultKey
      options = DATE_OPTIONS[key]

      if (key === defaultKey && UserService.isFreemiumOrganization()) {
        options = options.filter(function (option) {
          return invalidFreemiumOptions.indexOf(option.key) === -1
        })
      }

      vm.dropdownItems = options
      if (key != defaultKey) {
        vm.selected = options[0]
      }
      return options
    }

    function getPlaceholder() {
      return placeholder
    }

    function deleteDate() {
      if (vm.csDateRangeType != 'dropdown') {
        vm.model = { startDate: null, endDate: null }
      } else {
        setModelFromPreviousState()
      }
      vm.dropdownItems.forEach(function (obj) {
        obj.startDate = null
        obj.endDate = null
      })
      _propagateModelChange()
      state = csDateRangePickerPrimaryStates.SELECT
    }

    function onHide() {
      if (vm.csDateRangeType == 'dropdown' && !vm.model.startDateDropdown) {
        setModelFromPreviousState()
      }
      vm.dropdownItems.forEach(function (obj) {
        obj.startDate = null
        obj.endDate = null
      })
      _propagateModelChange()
      state = csDateRangePickerPrimaryStates.SELECT
    }

    function onSelect(index) {
      var item = options[index]
      onItemSelect(item)
    }

    function onItemSelect(item) {
      vm.selected = item
      var range
      if (item.getter) {
        range = TimeService[item.getter]()
        if (!vm.model) {
          vm.model = {}
        }
        vm.model.startDate = range.startDate
        vm.model.endDate = range.endDate
        vm.model.label = item.label
        state = csDateRangePickerPrimaryStates.SELECT
        _propagateModelChange()

        previousStateNonCustom = item
      } else {
        state = csDateRangePickerPrimaryStates.RANGE_PICKER
        range = TimeService.getLastWeek()
        if (!vm.model) {
          vm.model = {}
        }
        vm.model.startDate = range.startDate
        vm.model.endDate = range.endDate
      }
    }

    function onChange() {
      if (_modelIsValid()) {
        _propagateModelChange()
      }
    }

    function _modelIsValid() {
      if (!angular.isObject(vm.model)) {
        return false
      }
      var format = TimeService.getDateTimeFormat()
      return (
        vm.model.startDate &&
        vm.model.endDate &&
        moment(vm.model.startDate, format).isValid() &&
        moment(vm.model.endDate, format).isValid()
      )
    }

    function isState(str) {
      return state === str
    }

    function rangePickerOnChange() {
      vm.model.startDateDropdown = vm.model.startDate.toDate()
      vm.model.endDateDropdown = vm.model.endDate.toDate()
      vm.model.startDate = moment(vm.model.startDate).format(
        TimeService.getDateTimeFormat()
      )
      vm.model.endDate = moment(vm.model.endDate).format(
        TimeService.getDateTimeFormat()
      )
      _propagateModelChange()
      state = csDateRangePickerPrimaryStates.SELECT
    }

    function getPickerInputVal() {
      if (
        vm.model &&
        angular.isObject(vm.model) &&
        vm.model.startDate &&
        vm.model.endDate
      ) {
        return vm.model.startDate + ' - ' + vm.model.endDate
      }
      return ''
    }

    function _propagateModelChange() {
      var newVal = {
        startDate: vm.model.startDate,
        endDate: vm.model.endDate
      }
      if (vm.model.extraOptionsSelected) {
        newVal.extraOptionsSelected = vm.model.extraOptionsSelected
      }
      vm.rangeInputValue = newVal.startDate + ' - ' + newVal.endDate
      vm.propagateModelChange()
    }

    function openDropdown() {
      vm.isDropdownOpen = true
    }

    function setModelFromPreviousState() {
      if (previousStateNonCustom != null) {
        vm.selected = previousStateNonCustom
      } else {
        vm.selected = options[0]
      }
      var range = TimeService[vm.selected.getter]()
      if (!vm.model) {
        vm.model = {}
      }
      vm.model.startDate = range.startDate
      vm.model.endDate = range.endDate
    }

    function updateModel(model) {
      vm.model = model
      if (vm.csDateRangeType == 'dropdown') {
        var label = model.label ? model.label : 'Custom...',
          selectedOption = options.find(function (option) {
            return option.label == label
          })
        if (selectedOption) {
          vm.selected = selectedOption
        }
      }
    }
  }
})()
